<template>
  <v-container>
    <v-row justify="space-around">
      <v-col sm="12">
        <v-card outlined id="print">
          <v-card-text>
            <b>{{ ticket.name }}</b>
            <div>
              {{ ticket.notes }}
            </div>
            <br />
            <div>
              <b>Samples: </b>
              {{ ticket.samples }}
            </div>
            <br />
            <div v-if="ticket.rush">
              <b>RUSH ORDER</b>
            </div>
            <br />
            <div>Submitted: {{ ticket.created_on }}</div>
          </v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Coating</th>
                  <th>Raw Material</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="batch in ticket.batches" :key="batch.id">
                  <td>{{ batch.forgeID }}</td>
                  <td>{{ batch.name }}</td>
                  <td>{{ batch.workorder.coating.name }}</td>
                  <td v-if="batch.composition.length > 0">
                    <div v-for="raw in batch.composition" :key="raw.id">
                      <p>{{ raw.rawmaterial.barcode }}</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
      <v-col sm="12">
        <div>
          <v-btn @click.native="print">Print</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { BatchTicket } from "../../models/Ticket";
export default {
  name: "QualityCoatedPrint",
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    ticket() {
      return BatchTicket.query()
        .withAllRecursive()
        .find(parseInt(this.id));
    }
  },
  methods: {
    print() {
      // Get HTML to print from element
      let prtHtml = document.getElementById("print").innerHTML;
      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style')
      ]) {
        stylesHtml += node.outerHTML;
      }
      let WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );
      WinPrint.document.write(
        `<!DOCTYPE html>
          <html>
            <head>
              ${stylesHtml}
            </head>
            <body>
              ${prtHtml}
            </body>
          </html>`
      );
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    }
  }
};
</script>
